function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireac40"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireac40"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRequire.register("eL13W", function(module, exports) {

$parcel$export(module.exports, "getLocalStorage", () => $2a0a9d2c002157bd$export$d3720feff416e85b);
$parcel$export(module.exports, "setLocalStorage", () => $2a0a9d2c002157bd$export$1f73f60bdb811cb1);
$parcel$export(module.exports, "generateBreadcrumb", () => $2a0a9d2c002157bd$export$7f4d634b10993eb6);
$parcel$export(module.exports, "getParam", () => $2a0a9d2c002157bd$export$ecf541e09a511845);
$parcel$export(module.exports, "addMovieToStorage", () => $2a0a9d2c002157bd$export$73bcfb39fabe8205);
$parcel$export(module.exports, "addCommentToStorage", () => $2a0a9d2c002157bd$export$b61b48db6d2fd5e7);
$parcel$export(module.exports, "createScrollBtn", () => $2a0a9d2c002157bd$export$538bbf850262f928);
// retrieve data from localstorage
function $2a0a9d2c002157bd$export$d3720feff416e85b(key) {
    return JSON.parse(localStorage.getItem(key));
}
function $2a0a9d2c002157bd$export$1f73f60bdb811cb1(key, data) {
    localStorage.setItem(key, JSON.stringify(data));
}
function $2a0a9d2c002157bd$export$7f4d634b10993eb6(param = "", mainEl = document.querySelector("main")) {
    const breadcrumbNav = document.createElement("div");
    breadcrumbNav.classList.add("breadcrumb-navigation");
    const breadcrumbList = document.createElement("ul");
    breadcrumbList.classList.add("breadcrumb-list");
    // create the home link and add it to the breadcrumb list
    const homeLink = $2a0a9d2c002157bd$var$createBreadcrumbLink("Home", "/index.html");
    breadcrumbList.appendChild(homeLink);
    // get the current path of the page and split it into segments
    const currentPath = window.location.pathname;
    const pathSegments = currentPath.split("/").filter((segment)=>segment !== "");
    // variables to keep track of the path and previous segment
    let path = "/";
    let previousSegment = "";
    // iterate through the path segments
    for(let i = 0; i < pathSegments.length; i++){
        // append the current segment to the path
        path += pathSegments[i];
        // Check if the current segment is different from the previous segment
        if (pathSegments[i] !== "index.html" && pathSegments[i] !== previousSegment) {
            // create the segment link and add it to the breadcrumb list
            const segmentLink = $2a0a9d2c002157bd$var$createBreadcrumbLink(pathSegments[i], path);
            breadcrumbList.appendChild(segmentLink);
            // check if it is not the last segment to add a slash
            if (i !== pathSegments.length - 1) {
                const slash = document.createElement("span");
                slash.classList.add("breadcrumb-slash");
                slash.textContent = "/";
                breadcrumbList.appendChild(slash);
            }
        }
        // Update the previous segment
        previousSegment = pathSegments[i];
    }
    // Check if a parameter is provided and add it to the breadcrumb list
    if (param !== "") {
        const paramLink = $2a0a9d2c002157bd$var$createBreadcrumbLink(param);
        breadcrumbList.appendChild(paramLink);
    }
    // Append the breadcrumb list to the breadcrumb navigation container
    breadcrumbNav.appendChild(breadcrumbList);
    // Insert the breadcrumb navigation container at the beginning of the main element
    mainEl.insertAdjacentElement("afterbegin", breadcrumbNav);
}
// Function to create a breadcrumb link
function $2a0a9d2c002157bd$var$createBreadcrumbLink(text, href = "") {
    // only for the results page so it would not redirect towards an empty page
    if (text === "results") {
        const searchTerm = localStorage.getItem("searchTerm"); // retrieve the search term from local storage
        const searchParam = encodeURIComponent(searchTerm); // encode the search term for URL
        href = `/results/index.html?search=${searchParam}`;
    }
    // create the link element
    const link = document.createElement("a");
    link.href = href;
    link.textContent = text;
    // Create the list item element and add the link to it
    const listItem = document.createElement("li");
    listItem.classList.add("breadcrumb-item");
    listItem.appendChild(link);
    if (text === "Home") {
        // Create and append the slash element after the home link
        const slash = document.createElement("span");
        slash.classList.add("breadcrumb-home");
        slash.textContent = "/";
        listItem.appendChild(slash);
    }
    return listItem;
}
function $2a0a9d2c002157bd$export$ecf541e09a511845(param) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const url = urlParams.get(param);
    return url;
}
async function $2a0a9d2c002157bd$export$7a171f172be0782e(url) {
    const response = await fetch(url);
    const data = await response.json();
    console.log(data);
    return data;
}
function $2a0a9d2c002157bd$export$73bcfb39fabe8205(movie, list) {
    const favList = $2a0a9d2c002157bd$export$d3720feff416e85b(list) || [];
    const index = favList.findIndex((item)=>item.Title === movie.Title);
    if (index === -1) {
        favList.push({
            ...movie,
            poster: movie.Poster,
            title: movie.Title
        });
        $2a0a9d2c002157bd$export$1f73f60bdb811cb1(list, favList);
    }
}
function $2a0a9d2c002157bd$export$b61b48db6d2fd5e7(movie) {
    const comment = document.querySelector("#comment").value;
    const username = document.querySelector("#username").value;
    const mTitle = document.querySelector("#mTitle").value;
    const inputDate = document.querySelector("#formDateSend");
    const notice = document.querySelector(".notice");
    let d = new Date();
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    let date = `${months[d.getMonth()]}, ${d.getDate()} ${d.getFullYear()}`;
    let reviewLst = $2a0a9d2c002157bd$export$d3720feff416e85b("reviews") || [];
    if (!username == "" || !comment == "") {
        reviewLst.push({
            comment: comment,
            name: username,
            movie: mTitle,
            date: inputDate.value = date
        });
        $2a0a9d2c002157bd$export$1f73f60bdb811cb1("reviews", reviewLst);
        if (movie.Title) notice.innerHTML = `<p>Your Review for ${movie.Title} was added</p>`;
        else notice.innerHTML = `<p>Your Review for ${movie} was added</p>`;
        setTimeout(function() {
            window.location.reload();
        }, 4000);
    } else {
        console.log("comment not addewd");
        notice.innerHTML = `<p>There was an error and the comment was not added</p>`;
    }
}
function $2a0a9d2c002157bd$export$a339b9dfcf153d0e(img, movie, src) {
    const favList = $2a0a9d2c002157bd$export$d3720feff416e85b("fav-list") || [];
    img.src = src;
    $2a0a9d2c002157bd$export$1f73f60bdb811cb1("toggle-icon", true);
}

function $2a0a9d2c002157bd$export$538bbf850262f928() {
    const scrollBtn = document.createElement("img");
    scrollBtn.src = (parcelRequire("inaZa"));
    scrollBtn.setAttribute("id", "scroll-Btn");
    document.body.appendChild(scrollBtn);
    document.addEventListener("scroll", ()=>{
        scrollBtn.style.display = window.scrollY > 100 ? "block" : "none";
    });
    scrollBtn.addEventListener("click", ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    });
}

});
parcelRequire.register("inaZa", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("5r4Wf"), import.meta.url).toString();

});


parcelRequire.register("7CZe1", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("kmGN4"), import.meta.url).toString();

});

parcelRequire.register("d5W1w", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("k4mjQ"), import.meta.url).toString();

});

parcelRequire.register("dSysx", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("4WbAZ"), import.meta.url).toString();

});

parcelRequire.register("7KXuC", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("9bpf5"), import.meta.url).toString();

});

parcelRequire.register("iFzvp", function(module, exports) {
module.exports = JSON.parse('[{"title":"PLAN YOUR MOVIE!","message":"Schedule a movie with you family and friends","redirect":"../planning/index.html","callToAct":"Start Now"},{"title":"JOIN THE PARTY WITH JOHN WICK","message":" Action, Crime, Thriller. This movie will make you experiment what\'s feel to be alive","redirect":"../watch-party/index.html?movie=JOHN WICK%3A CHAPTER 4","callToAct":"Watch Now"},{"title":"Add, remove, plan.. ACTION!","message":"Visit your list to plan the next weekend movie night","redirect":"../user/index.html","callToAct":"Go To My List"},{"title":"INVITE YOUR FRIENDS","message":"Login and plan with your friend which movie to watch","redirect":"../login/index.html","callToAct":"Login Now"},{"title":"FALL IN LOVE WITH THE SOUND OF MUSIC","message":"A tuneful, heartwarming story, it is based on the real life story of the Von Trapp Family","redirect":"../watch-party/index.html?movie=The%20Sound%20of%20Music","callToAct":"Watch Now"}]');

});

var $7af79b9f580fb32a$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"ioUUD":"index.d35219f0.js","4WbAZ":"menuIcon.81807499.png","9bpf5":"icons8-x-48.9cf1b915.png","5r4Wf":"up.6fbf7732.png","kmGN4":"clap.6169e46d.png","k4mjQ":"film.8b63099c.png","8HnJD":"index.a864ddcd.js","bekjx":"index.bd0e629c.js"}'));

// creates the search box
function $ef9ead9c61ffd087$export$9eb1cf087813c7e() {
    const searchInput = document.createElement("input");
    searchInput.setAttribute("type", "text");
    searchInput.setAttribute("id", "searchInput");
    searchInput.setAttribute("placeholder", "Enter your search...");
    searchInput.classList.add("search-input");
    // create the search button element
    const searchButton = document.createElement("button");
    searchButton.setAttribute("id", "searchButton");
    searchButton.textContent = "\uD83D\uDD0D";
    searchButton.classList.add("search-button");
    const searchBox = document.createElement("div");
    searchBox.classList.add("search-box");
    searchBox.style.display = "inline-flex";
    searchBox.appendChild(searchInput);
    searchBox.appendChild(searchButton);
    // append the search box and button to the menu div
    const menuDiv = document.querySelector(".search-movie");
    menuDiv.prepend(searchBox);
}
function $ef9ead9c61ffd087$export$4b597114ade5582d(searchTerm) {
    localStorage.setItem("searchTerm", searchTerm);
    // Create URL parameters and set the search term
    const urlParams = new URLSearchParams();
    urlParams.set("search", searchTerm);
    // Get the root path of the website so we can uses the search box everywhere
    const rootPath = window.location.origin;
    // create the new URL with the search term as a parameter
    const newUrl = `${rootPath}/results/index.html?${urlParams.toString()}`;
    // redirect the page to the new URL
    window.location.href = newUrl;
}



var $75jjV = parcelRequire("75jjV");

var $eL13W = parcelRequire("eL13W");
// creates a container for movie posters
function $3ba5b6daed797c99$var$createPostersContainer(movies, createTemplate, className) {
    const postersContainer = document.createElement("div");
    postersContainer.classList.add(className);
    const template = createTemplate(movies);
    postersContainer.innerHTML = template;
    // set styles for the posters container
    postersContainer.style.display = "flex";
    postersContainer.style.flexDirection = "row";
    postersContainer.style.overflowX = "auto";
    postersContainer.style.gap = "10px";
    postersContainer.style.transform = "scale(0.8)";
    // set styles for poster images
    const posterImages = postersContainer.querySelectorAll("img");
    posterImages.forEach((img)=>{
        img.style.height = "500px";
        img.style.width = "300px";
        img.style.objectFit = "cover";
    });
    return postersContainer;
}


async function $3ba5b6daed797c99$export$5897d8d7c7a3d871(url = "", bannerText, mainBanner = true, sortByPopularity = false) {
    try {
        const mainElement = document.querySelector("main");
        const bannerSection = document.createElement("section");
        bannerSection.classList.add("bannerSection");
        const bannerDiv = document.createElement("div");
        bannerDiv.classList.add(mainBanner ? "banner" : "movie-list");
        const bannerTitleElement = mainBanner ? "h1" : "h2";
        const bannerTitle = document.createElement(bannerTitleElement);
        bannerTitle.textContent = bannerText;
        // if it's the main banner, create the banner message
        if (mainBanner) {
            const iconClap = (parcelRequire("7CZe1"));
            const bannerMessage = document.createElement("p");
            const clapImage = document.createElement("img");
            clapImage.src = iconClap;
            clapImage.alt = "clap icon";
            bannerMessage.appendChild(clapImage); // Append the image element to the paragraph
            // banner message 
            bannerMessage.innerHTML += "-- Lights, Camera, Action! Plan Your Perfect Movie Night. --";
            const iconFilm = (parcelRequire("d5W1w"));
            const filmImage = document.createElement("img");
            filmImage.src = iconFilm;
            filmImage.alt = "film icon";
            // add the icons to the message
            bannerMessage.appendChild(filmImage);
            // adds an h1 if it's the main banner
            bannerDiv.appendChild(bannerTitle);
            bannerDiv.appendChild(bannerMessage);
        } else // adds an h2 for any other list
        bannerDiv.appendChild(bannerTitle);
        // adds the different elements to the section and then to the document
        bannerSection.appendChild(bannerDiv);
        mainElement.appendChild(bannerSection);
        let bannerMovies; // declares the banner of movies that will be used
        if (url) {
            // if it gets an url, uses the getMovie function to get the results
            bannerMovies = await (0, $75jjV.getMovies)(url);
            // Sort the bannerMovies by popularity if specified
            if (sortByPopularity) bannerMovies.results.sort((a, b)=>b.popularity - a.popularity);
        } else {
            // otherwise uses the fetchMovieBySearch to more peronalized lists
            const randomWord = await $3ba5b6daed797c99$export$747c82712cf7560(); // popular keywords to get random movies in the discover list
            bannerMovies = await (0, $75jjV.fetchMovieBySearch)(randomWord);
        }
        // create the posters container based on the movie data and template function
        const postersContainer = $3ba5b6daed797c99$var$createPostersContainer(bannerMovies, $3ba5b6daed797c99$var$createTemplate, mainBanner ? "posters-container" : "list-container");
        bannerDiv.appendChild(postersContainer);
    } catch (error) {
        console.log("Error fetching trending movies:", error);
    }
}
async function $3ba5b6daed797c99$export$747c82712cf7560() {
    const popularWords = [
        "dark",
        "flower",
        "youth",
        "home",
        "fire",
        "little",
        "fantastic",
        "star",
        "lady",
        "one",
        "lost",
        "new",
        "love",
        "life",
        "night",
        "world",
        "meet"
    ];
    const randomWord = popularWords[Math.floor(Math.random() * popularWords.length)];
    // console.log(randomWord);
    return randomWord;
}
// function to create the template for movie posters
function $3ba5b6daed797c99$var$createTemplate(movies) {
    let template = "";
    if (movies && movies.results) // loop through movie results and create template for each movie
    movies.results.forEach((movie)=>{
        const movieTitle = movie.original_title;
        const image = movie.poster_path;
        template += `
        <div class="movie-details">
          <a href="/movie-details/index.html?movie=${movieTitle}">
            <img src="https://image.tmdb.org/t/p/w500/${image}" alt="${movieTitle} poster">
          </a>
        </div>
      `;
    });
    else if (movies && movies.Search) // loop through search results and create template for each movie
    movies.Search.forEach((movie)=>{
        const moviePoster = movie.Poster;
        const mediaType = movie.Type;
        const movieTitle = movie.Title;
        if (mediaType === "movie") template += `
          <div class="movie-details">
            <a href="/movie-details/index.html?movie=${movieTitle}">
              <img src="${moviePoster}" alt="${movieTitle} poster"/>
            </a>
          </div>`;
    });
    return template;
}
async function $3ba5b6daed797c99$export$2ff783c2bb2ac3b1() {
    const favList = (0, $eL13W.getLocalStorage)("fav-list");
    const searchTerm = localStorage.getItem("searchTerm");
    // if there is movies in the favlist, display this list, otherwise ignore it
    if (favList && favList.length !== 0) {
        // console.log(favList.length);
        const randomIndex = Math.floor(Math.random() * favList.length);
        const randomMovie = favList[randomIndex];
        const movieTitle = randomMovie.Title;
        // console.log(movieTitle);
        const movie = await (0, $75jjV.getMovies)(`search/movie?query=${encodeURIComponent(movieTitle)}`);
        const movieId = movie.results[0].id;
        $3ba5b6daed797c99$export$5897d8d7c7a3d871(`movie/${movieId}/recommendations?language=en-US&page=1`, "Recommendations", false, true);
    }
    // only if there is a searchTerm saved 
    if (searchTerm) {
        const movie = await (0, $75jjV.getMovies)(`search/movie?query=${encodeURIComponent(searchTerm)}`);
        const movieId = movie.results[0].id;
        $3ba5b6daed797c99$export$5897d8d7c7a3d871(`search/movie?query=${encodeURIComponent(searchTerm)}&language=en-US&page=1`, "Continue Exploring", false, true);
    }
}
async function $3ba5b6daed797c99$export$786d8b447d441f33() {
    await $3ba5b6daed797c99$export$2ff783c2bb2ac3b1(); // call the recommendationsList function first
    // define an array of objects containing the configurations for each list
    const lists = [
        {
            url: "movie/now_playing?language=en-US&page=1",
            title: "Currently in theatres",
            mainBanner: false
        },
        {
            url: "movie/top_rated?language=en-US&page=1",
            title: "Top Rated",
            mainBanner: false
        },
        {
            url: "discover/movie?include_adult=false&include_video=false&language=en-US&page=1&sort_by=vote_count.desc&with_genres=10751",
            title: "Family",
            mainBanner: false
        },
        {
            url: "discover/movie?include_adult=false&include_video=false&language=en-US&page=1&sort_by=popularity.desc&with_genres=28",
            title: "Action",
            mainBanner: false
        },
        {
            url: "discover/movie?include_adult=false&include_video=false&language=en-US&page=1&sort_by=vote_count.desc&with_genres=18",
            title: "Drama",
            mainBanner: false
        },
        {
            url: "discover/movie?include_adult=false&include_video=false&language=en-US&page=1&sort_by=popularity.desc&with_genres=9648",
            title: "Mystery",
            mainBanner: false
        },
        {
            url: "",
            title: "Discover",
            mainBanner: false
        }
    ];
    // execute the createList function for each list configuration using Promise.all
    await Promise.all(lists.map(({ url: url, title: title, mainBanner: mainBanner })=>$3ba5b6daed797c99$export$5897d8d7c7a3d871(url, title, mainBanner)));
}



var $eL13W = parcelRequire("eL13W");
function $e7d5ca7239cfce20$export$c2559589a6ea7c80(selector, list) {
    try {
        const favList = (0, $eL13W.getLocalStorage)(list) || [];
        const favEl = document.querySelector(selector);
        const favCtner = document.querySelector(".fav-container");
        const wtchCtner = document.querySelector(".watchlist-Container");
        if (!favList && favList.length === 0) favCtner.innerHTML = `<h3>Create your List</h3>
                              <p>Explore and add Movies to share with your friends!</p>`;
        if (!wtchCtner && wtchCtner.length === 0) wtchCtner.innerHTML = `<h3>Create your List</h3>
                              <p>Explore and add Movies to share with your friends!</p>`;
        // console.log(favList);
        // applied additional styling using js to experiment 
        favEl.style.display = "flex";
        favEl.style.flexDirection = "row";
        // favEl.style.justifyContent = "space-evenly";
        favEl.style.overflowX = "auto";
        favEl.style.gap = "10px";
        favEl.style.transform = "scale(0.8)";
        favEl.style.padding = "1rem";
        const movie = favList.map((item)=>{
            return `<li>
            <div class="delBtn" title="Delete '${item.Title}' from list"><button class="delete-movie" data-title="${item.Title}" data-lst="${list}"> X </button></div>
            <a href="/movie-details/index.html?movie=${item.Title}" > 
                <img src="${item.Poster}" alt="Poster of ${item.Title}" />
                <h3 class="movie-title">${item.Title} (${item.Year})</h3>
            </a>
        </li>`;
        });
        //  console.log(`here ${movie}`);
        favEl.innerHTML = movie.join("");
        const favImages = favEl.querySelectorAll("img"); // selecting all img elements within the fav list container
        favImages.forEach((img)=>{
            // applying additional styling to each image
            img.style.width = "250px";
            img.style.objectFit = "cover";
        });
        //HANDLE REMOVE MOVIE FROM LISTS
        const deleteBtn = document.querySelectorAll(".delete-movie");
        deleteBtn.forEach((del)=>{
            del.style.position = "absolute";
            del.style.right = "0";
            del.style.border = "1px solid #d0d0d0";
            del.style.backgroundColor = "#122936";
            del.style.color = "#d0d0d0";
            del.style.opacity = ".7";
            del.style.fontSize = "25px";
            del.style.cursor = "pointer";
            del.addEventListener("mouseover", ()=>{
                del.style.opacity = "1";
                del.style.color = "#fff";
                del.style.padding = ".3rem";
                setTimeout(()=>{
                    del.style.color = "#d0d0d0";
                    del.style.opacity = ".7";
                    del.style.padding = ".2rem";
                }, 1000);
            });
            del.addEventListener("click", ()=>{
                const movieTitle = del.getAttribute("data-title");
                const movieLst = del.getAttribute("data-lst");
                const index = favList.findIndex((item)=>item.Title === movieTitle);
                if (index !== -1 && movieLst === list) {
                    favList.splice(index, 1);
                    (0, $eL13W.setLocalStorage)(movieLst, favList);
                    setTimeout(function() {
                        window.location.reload();
                    }, 1000);
                }
            });
        });
    } catch (err) {
        console.log("Error, could not create list:", err);
    }
}



var $9xaVL = parcelRequire("9xaVL");

var $eL13W = parcelRequire("eL13W");
function $2e0f731592f515ed$export$98a4d7f3a5ab0973() {
    const menu = document.querySelector(".menu");
    menu.innerHTML = $2e0f731592f515ed$var$renderNav();
    const priNav = document.querySelector("#primaryNav");
    const navEl = document.querySelector("nav");
    const x = document.querySelector("#hamburgerBtn");
    x.style.backgroundColor = "transparent";
    x.style.border = "none";
    x.style.cursor = "pointer";
    x.addEventListener("mouseover", ()=>{
        x.style.opacity = ".7";
        setTimeout(()=>{
            x.style.opacity = "1";
        }, 1000);
    });
    x.addEventListener("click", ()=>{
        priNav.classList.toggle("open");
        x.classList.toggle("open");
        navEl.classList.toggle("open");
    });
}


function $2e0f731592f515ed$var$renderNav() {
    return `<nav>
    <button id="hamburgerBtn">
        <span><img src="${(parcelRequire("dSysx"))}" alt="hamburger menu icon"></span>
        <span><img src="${(parcelRequire("7KXuC"))}" alt="close menu icon"></span>
    </button>
    <ul id="primaryNav">
        <li><a href="/user/index.html">Profile</a></li>
        <li><a href="/planning/index.html">Planner</a></li>
        <li><a href="/watch-party/index.html">Watch Party</a></li>
    </ul>
  </nav> `;
}



async function $37977d0afc8e3c39$export$25930585b509fda1() {
    const popupsData = (parcelRequire("iFzvp"));
    //
    // const response = await fetch("../public/json/alert.json");
    // if (response.ok) {
    //   let data = await response.json();
    //   console.log(data)
    $37977d0afc8e3c39$var$displayResults(popupsData);
// } else {
//   throw new Error("Bad Response");
// }
}
function $37977d0afc8e3c39$var$displayResults(data) {
    const main = document.querySelector("main");
    const section = document.createElement("section");
    const closeBtn = document.createElement("button");
    const list = [];
    section.classList.add("alert-list");
    section.style.backgroundColor = "var(--light-grey)";
    section.style.position = "fixed";
    section.style.zIndex = "5";
    //section.style.height = "30%";
    section.style.maxWidth = "400px";
    section.style.transform = "translateX(-100%)";
    section.style.transition = "1s ease-in-out";
    section.style.padding = "2rem";
    section.style.left = "0";
    section.style.bottom = "20%";
    closeBtn.classList.add("close-btn");
    closeBtn.innerHTML = "X";
    closeBtn.style.position = "absolute";
    closeBtn.style.right = "0";
    closeBtn.style.top = "0";
    closeBtn.style.border = "none";
    closeBtn.style.fontWeight = "bold";
    closeBtn.style.backgroundColor = "transparent";
    closeBtn.addEventListener("mouseover", ()=>{
        closeBtn.style.color = "red";
        setTimeout(()=>{
            closeBtn.style.color = "black";
        }, 1000);
    });
    //iterate though alerts.json
    data.forEach((item)=>{
        const h1 = document.createElement("h1");
        const p = document.createElement("p");
        const a = document.createElement("a");
        const message = document.createElement("p");
        h1.innerHTML = item.title;
        h1.style.color = "var(--primary-color)";
        message.innerHTML = item.message;
        message.style.padding = ".5rem";
        a.innerHTML = item.callToAct;
        a.setAttribute("href", item.redirect);
        a.style.color = "var(--secondary-color)";
        a.style.padding = ".2rem";
        a.addEventListener("mouseover", ()=>{
            a.style.border = "1px solid #40125f";
        });
        a.addEventListener("mouseout", ()=>{
            a.style.border = "none";
        });
        message.style.color = "var(--primary-color)";
        let template = `<h2 style="color: var(--primary-color);">${item.title}</h2>
        <p style="padding: .5rem; color: var(--primary-color);">${item.message}</p>
        <a href="${item.redirect}" style="color: var(--secondary-color);">${item.callToAct}</a>
        `;
        list.push(template);
    // section.appendChild(h1)
    // section.appendChild(message)
    // section.appendChild(a)
    });
    let randomp = list[Math.floor(Math.random() * list.length)];
    section.appendChild(closeBtn);
    section.insertAdjacentHTML("beforeend", randomp);
    main.appendChild(section);
    setTimeout(()=>{
        section.style.transform = "translateX(0)";
    }, 4000);
    closeBtn.addEventListener("click", ()=>{
        section.style.display = "none";
    });
}


// event listener to make sure the dom is loaded before the js is executed
document.addEventListener("DOMContentLoaded", ()=>{
    const searchButton = document.querySelector("#searchButton");
    const searchInput = document.querySelector("#searchInput");
    //  event listener for when the research is sent
    searchButton.addEventListener("click", ()=>{
        const searchTerm = searchInput.value; // getting the value from the search input
        (0, $ef9ead9c61ffd087$export$4b597114ade5582d)(searchTerm); // redirecting to the search results page with the search term
    });
    (0, $9xaVL.initialize)() // displays the watchparty section
    ;
});
(0, $ef9ead9c61ffd087$export$9eb1cf087813c7e)(); // creates the search box component
(0, $2e0f731592f515ed$export$98a4d7f3a5ab0973)();
(0, $3ba5b6daed797c99$export$5897d8d7c7a3d871)("trending/movie/week?language=en-US", "Welcome to Movie Night Planner!");
(0, $3ba5b6daed797c99$export$786d8b447d441f33)();
(0, $eL13W.createScrollBtn)();
(0, $37977d0afc8e3c39$export$25930585b509fda1)();


//# sourceMappingURL=index.d35219f0.js.map
